import { Box, Button, TextField, InputAdornment, CircularProgress, Typography, List, ListItem, ListItemText, Container } from "@mui/material";
import AddFieldsImage from "../../../../../../public/images/addFieldsImage.png";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { useTranslation } from "react-i18next";
interface Props {
  onAddField: () => void;
}
export const FieldEmptyState = ({
  onAddField
}: Props) => {
  const {
    t
  } = useTranslation();
  return <Container disableGutters maxWidth={false} sx={{
    height: "100%",
    maxWidth: "700px"
  }} data-sentry-element="Container" data-sentry-component="FieldEmptyState" data-sentry-source-file="FieldEmptyState.tsx">
      <Box data-cy="FieldEmptyState" width="100%" height="100%" display="flex" flexDirection="row" alignItems="center" gap={7} justifyContent="space-between" pl={4} data-sentry-element="Box" data-sentry-source-file="FieldEmptyState.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="FieldEmptyState.tsx">
          <Typography variant="h4" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="FieldEmptyState.tsx">
            {t("schema.addFieldsHeading")}
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1} data-sentry-element="Typography" data-sentry-source-file="FieldEmptyState.tsx">
            {t("schema.addFieldsDescription")}
          </Typography>
          <Button variant="contained" startIcon={<AddRoundedIcon />} onClick={() => onAddField()} sx={{
          mt: 2
        }} size="small" data-sentry-element="Button" data-sentry-source-file="FieldEmptyState.tsx">
            {t("schema.addField")}
          </Button>
          <Box mt={3} data-sentry-element="Box" data-sentry-source-file="FieldEmptyState.tsx">
            {/* @ts-ignore */}
            <Typography variant="body3" data-sentry-element="Typography" data-sentry-source-file="FieldEmptyState.tsx">{t("schema.needHelp")}</Typography>
            <List sx={{
            listStyleType: "disc",
            ml: 2,
            pt: 0
          }} data-sentry-element="List" data-sentry-source-file="FieldEmptyState.tsx">
              <ListItem sx={{
              display: "list-item",
              p: 0,
              cursor: "pointer"
            }} onClick={() => window.open("https://zesty.org/services/manager-ui/schema#content-fields-types", "_blank")} data-sentry-element="ListItem" data-sentry-source-file="FieldEmptyState.tsx">
                <ListItemText primaryTypographyProps={{
                variant: "body3",
                color: "info.dark"
              }} data-sentry-element="ListItemText" data-sentry-source-file="FieldEmptyState.tsx">
                  {t("schema.readFieldTypesGuide")}
                </ListItemText>
              </ListItem>
              <ListItem sx={{
              display: "list-item",
              p: 0,
              cursor: "pointer"
            }} data-sentry-element="ListItem" data-sentry-source-file="FieldEmptyState.tsx">
                <ListItemText primaryTypographyProps={{
                variant: "body3",
                color: "info.dark"
              }} onClick={() => window.open("https://zesty.org/quick-start-guide/creating-a-content-model", "_blank")} data-sentry-element="ListItemText" data-sentry-source-file="FieldEmptyState.tsx">
                  {t("schema.learnBestPracticesModels")}
                </ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box component="img" src={AddFieldsImage} sx={{
        width: "277px",
        height: "192.25px"
      }} data-sentry-element="Box" data-sentry-source-file="FieldEmptyState.tsx" />
      </Box>
    </Container>;
};